import { cursorToEnd } from "~/helpers/input_helpers"
import { Controller } from "@hotwired/stimulus"

// A form controller extension for inline editing inputs (single input forms).
// Connects to data-controller="inline-form"
export default class InlineFormController extends Controller<HTMLFormElement> {
  static targets = ["input"]
  declare readonly inputTarget: HTMLInputElement
  private originalValue?: string

  connect() {
    this.originalValue = this.inputTarget.value
    this.focusInput()
    cursorToEnd(this.inputTarget)
  }

  focusInput() {
    this.inputTarget.focus()
  }

  submit() {
    if (this.inputTarget.disabled) return

    this.element.requestSubmit()

    // Even though `submit` internally calls `requestSubmit` which validates the form, we have no way to know whether
    // the form is valid or not to disable the `inputTarget`. So we need to check it manually.
    if (this.element.checkValidity()) {
      this.inputTarget.disabled = true
    }
  }

  abort() {
    if (this.originalValue) this.inputTarget.value = this.originalValue

    this.submit()
  }
}
